export default [
    {
        path: 'positions',
        name: 'partner-positions',
        meta: {
            anyFromModules: true,
            modules: ['deployment', 'crm'],
            authentication_required: true,
            authorization_required: ['roles.positions.view'],
            translate: (t) => {
                return t('menu_points.positions').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'partner-positions-list'},
        children: [
            {
                path: '',
                name: 'partner-positions-list',
                meta: {
                    anyFromModules: true,
                    modules: ['deployment', 'crm'],
                    authentication_required: true,
                    authorization_required: ['roles.positions.view'],
                    translate: (t) => {
                        return t('menu_points.positions').ucFirst();
                    },
                },
                component: () => import('@/views/pages/partners/positions/list.vue'),
            },
            {
                path: 'create',
                name: 'partner-position-create',
                meta: {
                    anyFromModules: true,
                    modules: ['deployment', 'crm'],
                    authentication_required: true,
                    authorization_required: ['roles.positions.create'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('partners::positions.position', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/partners/positions/item.vue')
            },
            {
                path: ':id(\\d+)',
                name: 'partner-position-edit',
                meta: {
                    anyFromModules: true,
                    modules: ['deployment', 'crm'],
                    authentication_required: true,
                    authorization_required: ['roles.positions.edit'],
                    translate: (t, tc) => t('base.edit_item', {item: tc('partners::positions.position', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/partners/positions/item.vue')
            },
        ]
    },
    {
        path: 'company-sizes',
        name: 'partner-company-sizes',
        meta: {
            anyFromModules: true,
            modules: ['deployment', 'crm'],
            authentication_required: true,
            authorization_required: ['roles.company_sizes.view'],
            translate: (t) => {
                return t('menu_points.company_sizes').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'partner-company-sizes-list'},
        children: [
            {
                path: '',
                name: 'partner-company-sizes-list',
                meta: {
                    anyFromModules: true,
                    modules: ['deployment', 'crm'],
                    authentication_required: true,
                    authorization_required: ['roles.company_sizes.view'],
                    translate: (t) => {
                        return t('menu_points.company_sizes').ucFirst();
                    },
                },
                component: () => import('@/views/pages/partners/company-sizes/list.vue'),
            },
            {
                path: 'create',
                name: 'partner-company-size-create',
                meta: {
                    anyFromModules: true,
                    modules: ['deployment', 'crm'],
                    authentication_required: true,
                    authorization_required: ['roles.company_sizes.create'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('partners::company_sizes.company_size', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/partners/company-sizes/item.vue')
            },
            {
                path: ':id(\\d+)',
                name: 'partner-company-size-edit',
                meta: {
                    anyFromModules: true,
                    modules: ['deployment', 'crm'],
                    authentication_required: true,
                    authorization_required: ['roles.company_sizes.edit'],
                    translate: (t, tc) => t('base.edit_item', {item: tc('partners::company_sizes.company_size', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/partners/company-sizes/item.vue')
            },
        ]
    },
    {
        path: 'industries',
        name: 'partner-industries',
        meta: {
            anyFromModules: true,
            modules: ['deployment', 'crm'],
            authentication_required: true,
            authorization_required: ['roles.industries.view'],
            translate: (t) => {
                return t('menu_points.industries').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'partner-industries-list'},
        children: [
            {
                path: '',
                name: 'partner-industries-list',
                meta: {
                    anyFromModules: true,
                    modules: ['deployment', 'crm'],
                    authentication_required: true,
                    authorization_required: ['roles.industries.view'],
                    translate: (t) => {
                        return t('menu_points.industries').ucFirst();
                    },
                },
                component: () => import('@/views/pages/partners/industries/list.vue'),
            },
            {
                path: 'create',
                name: 'partner-industry-create',
                meta: {
                    anyFromModules: true,
                    modules: ['deployment', 'crm'],
                    authentication_required: true,
                    authorization_required: ['roles.industries.create'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('partners::industries.industry', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/partners/industries/item.vue')
            },
            {
                path: ':id(\\d+)',
                name: 'partner-industry-edit',
                meta: {
                    anyFromModules: true,
                    modules: ['deployment', 'crm'],
                    authentication_required: true,
                    authorization_required: ['roles.industries.edit'],
                    translate: (t, tc) => t('base.edit_item', {item: tc('partners::industries.industry', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/partners/industries/item.vue')
            },
        ]
    },
    {
        path: 'acquisitions',
        name: 'partner-acquisitions',
        meta: {
            anyFromModules: true,
            modules: ['deployment', 'crm'],
            authentication_required: true,
            authorization_required: ['roles.acquisitions.view'],
            translate: (t) => {
                return t('menu_points.acquisitions').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'partner-acquisitions-list'},
        children: [
            {
                path: '',
                name: 'partner-acquisitions-list',
                meta: {
                    anyFromModules: true,
                    modules: ['deployment', 'crm'],
                    authentication_required: true,
                    authorization_required: ['roles.acquisitions.view'],
                    translate: (t) => {
                        return t('menu_points.acquisitions').ucFirst();
                    },
                },
                component: () => import('@/views/pages/partners/acquisitions/list.vue'),
            },
            {
                path: 'create',
                name: 'partner-acquisition-create',
                meta: {
                    anyFromModules: true,
                    modules: ['deployment', 'crm'],
                    authentication_required: true,
                    authorization_required: ['roles.acquisitions.create'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('partners::acquisitions.acquisition', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/partners/acquisitions/item.vue')
            },
            {
                path: ':id(\\d+)',
                name: 'partner-acquisition-edit',
                meta: {
                    anyFromModules: true,
                    modules: ['deployment', 'crm'],
                    authentication_required: true,
                    authorization_required: ['roles.acquisitions.edit'],
                    translate: (t, tc) => t('base.edit_item', {item: tc('partners::acquisitions.acquisition', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/partners/acquisitions/item.vue')
            },
        ]
    },
    {
        path: 'partner-sources',
        name: 'partner-sources',
        meta: {
            anyFromModules: true,
            modules: ['deployment', 'crm'],
            authentication_required: true,
            authorization_required: ['roles.partner_sources.view'],
            translate: (t) => {
                return t('menu_points.partner_sources').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        redirect: { name: 'partner-sources-list'},
        children: [
            {
                path: '',
                name: 'partner-sources-list',
                meta: {
                    anyFromModules: true,
                    modules: ['deployment', 'crm'],
                    authentication_required: true,
                    authorization_required: ['roles.partner_sources.view'],
                    translate: (t) => {
                        return t('menu_points.partner_sources').ucFirst();
                    },
                },
                component: () => import('@/views/pages/partners/sources/list.vue'),
            },
            {
                path: 'create',
                name: 'partner-source-create',
                meta: {
                    anyFromModules: true,
                    modules: ['deployment', 'crm'],
                    authentication_required: true,
                    authorization_required: ['roles.partner_sources.create'],
                    translate: (t, tc) => t('base.create_new_item', {item: tc('partners::sources.source', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/partners/sources/item.vue')
            },
            {
                path: ':id(\\d+)',
                name: 'partner-source-edit',
                meta: {
                    anyFromModules: true,
                    modules: ['deployment', 'crm'],
                    authentication_required: true,
                    authorization_required: ['roles.partner_sources.edit'],
                    translate: (t, tc) => t('base.edit_item', {item: tc('partners::sources.source', 1)}).ucFirst()
                },
                component: () => import('@/views/pages/partners/sources/item.vue')
            },
        ]
    },
];